/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Meet New People, Chat, Socialize",
      "Incorrect phone number",
      "Get the app",
      "Continue With Apple",
      "Continue With Facebook",
      "Continue With Google",
      "Log In",
      "Sign Up",
      "To continue, please enter the characters you see into the input field.",
      "Continue",
      "Enter characters",
      "Security check",
      "Reload",
      "Create a new password, which you will easily remember:",
      "Update",
      "Confirm password",
      "Password must be at least {{num}} [[characters:num]]",
      "Password",
      "Create new password",
      "Badoo - The Blog",
      "Careers",
      "Chat",
      "Cities",
      "Manage cookies",
      "Copyright © 2006 – present. Bumble. All rights reserved.",
      "Apple and the Apple logo are trademarks of Apple Inc.{{__EOL__}}Google Play is a trademark of Google LLC.",
      "Download",
      "Facebook",
      "Follow us",
      "Help Center",
      "Instagram",
      "Language",
      "LinkedIn",
      "Overview",
      "Badoo is part of Bumble Inc.",
      "Privacy policy",
      "Safety Center",
      "Sitemap",
      "Modern Slavery Act statement",
      "Terms and conditions",
      "Twitter",
      "Enter your email or cell number and we'll send you instructions to create a new password.",
      "Get New Password",
      "Enter your email or phone number",
      "Forgotten password",
      "Models used for illustrative purposes only",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "There’s no need to wait for a match.{{__EOL__}}{{__EOL__}}Dive into the chats that go a little deeper, and get straight to the good stuff. You know, the bit where you really get to know each other.",
      "Ready to chat now?",
      "By signing up, you agree to our <a class=\"link\" href=\"{{terms_url}}\">Terms & Conditions</a>. Learn how we use your data in our <a class=\"link\" href=\"{{privacy_url}}\">Privacy Policy</a>",
      "Helping to put more of the real you in, <br />for dating you feel good about.",
      "Here’s to dating with confidence.",
      "Or",
      "Already have an account?",
      "Sign up with your email or phone number",
      "Get what you want out of dating.{{__EOL__}}No need to apologise.",
      "Just want to chat? That's OK.{{__EOL__}}Ready to settle down? Love that.{{__EOL__}}{{__EOL__}}And if you ever change your mind, you absolutely can.",
      "Here to date",
      "Ready for a relationship",
      "Open to chat",
      "Meet people who want the same thing.",
      "{{name}}, {{age}}",
      "Your safety is our number one priority.",
      "Our Safety Center is a knowledge hub, containing all the support you need to date with confidence.",
      "Visit our Safety Center",
      "Safety first,<br/>second, and always.",
      "From the very first moment, I thought it was going to work…",
      "At first, I wasn’t looking for anything serious…",
      "One piece of advice for anyone on the Badoo App would be to be themselves...",
      "Badoo Success Stories",
      "Check out more success stories",
      "{{num}}__CUT__Rating",
      "Apple App Store",
      "Trust us. We've brought millions (and millions, and millions) of people together since 2006.",
      "{{num}}M+__CUT__Downloads",
      "{{num}}M+",
      "Google Play Store",
      "We know what we’re doing.",
      "Log in with your email or phone number",
      "Enter your password",
      "Forgotten Password?",
      "Sign Up",
      "Don’t have an account?",
      "Login",
      "Sign up"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "characters"
            ],
            "singular": [
                  "character"
            ]
      },
      "day": {
            "plural": [
                  "days"
            ],
            "singular": [
                  "day"
            ]
      },
      "hour": {
            "plural": [
                  "hours"
            ],
            "singular": [
                  "hour"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "months"
            ],
            "singular": [
                  "month"
            ]
      },
      "second": {
            "plural": [
                  "seconds"
            ],
            "singular": [
                  "second"
            ]
      },
      "year": {
            "plural": [
                  "years"
            ],
            "singular": [
                  "year"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
